import {
  Component,
  AfterViewInit,
  AfterViewChecked,
  Input,
  ChangeDetectorRef,
  ElementRef,
  OnInit,
  OnChanges,
  ViewEncapsulation, SimpleChanges, AfterContentChecked
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GroupBy } from "../../../../Common/Interfaces/GroupBy";
import { ProductsService } from "../../../../Common/Services/products.service";
import { IApiResponse } from "../../../../Common/Interfaces/IApiResponse";
import { IFinish } from "../../../../Common/Interfaces/IFinish";
import { PropertiesService } from "../../../../Common/Services/properties.service";
import { IVariantGrouping} from "../../../../Common/Interfaces/IVariantGrouping";
import { IVariantGroupingType} from "../../../../Common/Interfaces/IVariantGroupingType";
import { ISelectedFilter } from "../../../../Common/Interfaces/ISelectedFilter";
import {ICategoryBrowseFilterOptions} from "../../../../Common/Interfaces/ICategoryBrowseFilterOptions";
import {logging} from "selenium-webdriver";
import 'rxjs/add/observable/from';

import IType = logging.IType;
import {Observable} from "rxjs/Observable";
import {IFilterResultCategoryBrowsing} from "../../../../Common/Interfaces/IFilterResultCategoryBrowsing";
import {IStyle} from "../../../../Common/Interfaces/IStyle";
import TranslationsService from "../../../../Common/Services/translations.service";

@Component({
  selector: 'kws-category-browsing',
  templateUrl: './category-browsing.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CategoryBrowsingComponent implements OnInit, AfterViewInit, AfterContentChecked, AfterViewChecked, OnChanges {
  private route: ActivatedRoute;
  @Input() cat: string;
  @Input() secondaryCat: string;
  @Input() type: string;
  @Input() subtype: string;
  @Input() compareAllUrl: string;
  @Input() groupBy: string = GroupBy.TYPES;
  @Input() sectionNav: boolean = true;
  @Input() displayType: string;
  finishes: IFinish[];
  styles: IStyle[];
  finishDisplayTitle: string = 'Finish';
  isShowingAllFinishes: boolean = false;
  variantGroupings: IVariantGrouping;
  variantGroupingType: IVariantGroupingType[];
  defaultFinish: string;
  selectedFilters: ISelectedFilter[] = [];
  queryParams;
  tab: string;
  finish: string;
  products: IVariantGrouping[];
  translationsService: TranslationsService;

  constructor(translationsService: TranslationsService, public cd: ChangeDetectorRef, public productsService: ProductsService, elementRef: ElementRef, route: ActivatedRoute, private propertiesService: PropertiesService) {
    this.route = route;
    this.productsService.updateUrlParams = true;
    this.translationsService = translationsService;

    if (this.propertiesService.get('sectionNav')) {
      this.sectionNav = this.propertiesService.get('sectionNav');
    }

    if (this.propertiesService.get('type')) {
      this.type = this.propertiesService.get('type');
    }

    if (this.propertiesService.get('subtype')) {
      this.subtype = this.propertiesService.get('subtype');
    }

    if (this.propertiesService.get('compareAllUrl')) {
      this.compareAllUrl = this.propertiesService.get('compareAllUrl');
    }

    if (this.propertiesService.get('displayType')) {
      this.displayType = this.propertiesService.get('displayType');
    }

    if (this.propertiesService.get('cat')) {
      this.cat = this.propertiesService.get('cat');
    }

    if (this.propertiesService.get('secondaryCat')) {
      this.secondaryCat = this.propertiesService.get('secondaryCat');
    }

    if (this.propertiesService.get('defaultFinish')) {
      this.defaultFinish = this.propertiesService.get('defaultFinish');
    }

    if (this.propertiesService.get('groupBy')) {
      this.groupBy = this.propertiesService.get('groupBy');
    }
  }

  ngOnInit() {
      /*
      this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: { finish: this.defaultFinish, type: (this.type ? this.type : "") },
        queryParamsHandling: "merge"
      });
      */

    console.log(`secondary cat is: ${this.secondaryCat}`);

    this.productsService.paramUpdated$.subscribe(param => {
      if (param.name === 'finish') {
        this.finish = this.productsService.getFilterOption('finish');
      } else if (param.name === 'type') {
        this.type = this.productsService.getFilterOption('type');
      } else if (param.name === 'subtype') {
        this.subtype = this.productsService.getFilterOption('subtype');
      }
    });

    // Whenever the query string parameters change...
    this.route.queryParamMap.subscribe((params) => {
      this.productsService.setFilterOptionsFromQueryParams(params);
      this.selectedFilters = [];
      this.queryParams = params;
      this.updateSelectedFiltersFromQueryParams();

      this.productsService.loadFilterResults(this.cat, this.secondaryCat, this.groupBy, this.type, this.queryParams.finish ).subscribe((response: IApiResponse<any>) => {
        let data = response.data;
        this.finishes = data.availableFinishes;
        this.styles = data.styles;
        this.variantGroupingType = data.variantGroupingTypes;
        console.log('data:', data);
        this.finishDisplayTitle = this.isPadlockCategory() ? 'Color' : (data.finishDisplayTitle || 'Finish');
        this.isShowingAllFinishes = data.isShowingAllFinishes === true && this.isPadlockCategory() && !params.get('finish');
        // added to show complete sets first on the handlesets page
        if (this.cat.toLowerCase() === "handlesets") {
          this.variantGroupingType = data.variantGroupingTypes.sort((a, b) => (a.type.title > b.type.title) ? 1 : ((b.type.title > a.type.title) ? -1 : 0));
        }

        console.log(data);

        switch(this.groupBy) {
          case GroupBy.TYPES:
            this.getResultsByTypeOrSubtype(this.variantGroupingType, this.groupBy, this.type, this.subtype, this.queryParams.params, this.finishes);
              break;
          case GroupBy.SUBTYPES:
            this.getResultsByTypeOrSubtype(this.variantGroupingType, this.groupBy, this.type, this.subtype, this.queryParams.params, this.finishes);
            break;
          case GroupBy.STYLESFUNCTIONS:
            this.getResultsByStyle(this.styles, this.groupBy, this.type, this.subtype, this.queryParams.params, this.finishes);
              break;
          default:
            // code block
        }
      });
    });
  }

  ngAfterViewInit() {
  }

  ngAfterViewChecked() {
  }

  ngOnChanges(){

  }

  ngAfterContentChecked() {

  }

  updateSelectedFiltersFromQueryParams() {
    this.selectedFilters = [];
    for (let nextParam of this.queryParams.keys) {
      this.updateSelectedFilters(nextParam, this.queryParams.get(nextParam));
    }
  }

  updateParam(name: string, value: any, replaceValue?: boolean) {
    this.productsService.updateParam(name, value, replaceValue);
  }

  updateSelectedFilters(name: string, value: any) {

  }

  isPadlockCategory(): boolean {
    return this.cat === 'padlocks' || this.secondaryCat === 'padlocks';
  }

  getResultsByStyle(styles: IStyle[], groupBy:string, type: string, subtype: string, param: ICategoryBrowseFilterOptions, finishes: IFinish[]) {

    let products = [];

    for(let i = 0; i < styles.length; i++) {
      let style = styles[i];

      let styleFinishes = style.finishes;
      let finishList = finishes;
      this.cd.detectChanges();
      let slugOfCurrentFinish;
      let nameOfCurrentFinish;

      if (this.isShowingAllFinishes) {
        style.unavailable = false;
        style.selectedFinish = '';
        products.push(style);
        continue;
      }

      //set the finish for the active slug
      for(let i = 0; i < finishList.length; i++) {
        if(finishList[i].isSelected) {
          slugOfCurrentFinish = finishList[i].slug;
          nameOfCurrentFinish = finishList[i].title;
        }
      }

      //swap out primary image with the image for the finish selected
      for(let i= 0; i < styleFinishes.length; i++) {
        if(styleFinishes[i].slug === slugOfCurrentFinish) {
          style.image = styleFinishes[i].productImage;
        }
      }

      //set whether the product is availalbe in the finish or not
      if(styleFinishes.some(e => e.slug === slugOfCurrentFinish)) {
        style.unavailable = false;
      } else {
        style.unavailable = true;
      }

      style.selectedFinish = nameOfCurrentFinish;

      this.cd.detectChanges();

      products.push(style);
    }

    this.styles = products;
  }

  getResultsByTypeOrSubtype(variantTypes, groupBy, type, subtype, param: ICategoryBrowseFilterOptions, finishes) {
    let products = [];

    //loop through all variantGroupingTypes;
    for(let i = 0; i < variantTypes.length; i++) {
      let variantGrouping = variantTypes[i].variantGroupings;

      //loop through all the variantGroupings
      for(let j = 0; j < variantGrouping.length; j++ ) {
        // console.log(variantGrouping[j]);
        let variantGroupingFinishes = variantGrouping[j].finishes;

        let finishList = finishes;
        this.cd.detectChanges();
        let slugOfCurrentFinish;

        if (this.isShowingAllFinishes) {
          variantGrouping[j].unavailable = false;

          if(variantGrouping[j].type.title === type) {
            products.push(variantGrouping[j]);
          }

          continue;
        }

        //set the finish for the active slug
        for(let i = 0; i < finishList.length; i++) {
          if(finishList[i].isSelected) {
            slugOfCurrentFinish = finishList[i].slug;
          }
        }

        //swap out primary image with the image for the finish selected
        for(let i= 0; i < variantGroupingFinishes.length; i++) {
          if(variantGroupingFinishes[i].slug === slugOfCurrentFinish) {
            variantGrouping[j].primaryImage = variantGroupingFinishes[i].productImage;
            variantGrouping[j].variantSlug = variantGroupingFinishes[i].variantSlug;
          }
        }

        //set whether the product is availalbe in the finish or not
        if(variantGroupingFinishes.some(e => e.slug === slugOfCurrentFinish)) {
          variantGrouping[j].unavailable = false;
        } else {
          variantGrouping[j].unavailable = true;
        }

        this.cd.detectChanges();

        if(variantGrouping[j].type.title === type) {
          products.push(variantGrouping[j]);
        }
      }
    }

    this.products = products;
  }

}



// WEBPACK FOOTER //
// ./src/ts/Apps/CategoryBrowsing/src/app/category-browsing/category-browsing.component.ts